var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "usersStatsListContainer", staticClass: "container mb-5" },
    [
      _c("div", { staticClass: "k-tabs" }, [
        _c("ul", { staticClass: "k-tabs__list" }, [
          _c(
            "li",
            {
              staticClass: "k-tabs__item",
              class: [{ "k-tabs__item--active": _vm.activeTab === "last24" }],
              on: {
                click: function($event) {
                  return _vm.tabChanged("last24")
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "k-tabs__link",
                  attrs: { href: "javascript:;" }
                },
                [_vm._v("Posledních 24 hodin")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "k-tabs__item",
              class: [
                { "k-tabs__item--active": _vm.activeTab === "lastMonth" }
              ],
              on: {
                click: function($event) {
                  return _vm.tabChanged("lastMonth")
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "k-tabs__link ",
                  attrs: { href: "javascript:;" }
                },
                [_vm._v("Poslední měsíc")]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "k-tabs__item",
              class: [{ "k-tabs__item--active": _vm.activeTab === "total" }],
              on: {
                click: function($event) {
                  return _vm.tabChanged("total")
                }
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "k-tabs__link ",
                  attrs: { href: "javascript:;" }
                },
                [_vm._v("Celkem")]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.users.data && _vm.users.data.length > 0
        ? [
            _c(
              "div",
              { staticClass: "k-table k-table--user-stats" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "transition-group",
                  { attrs: { name: "list-complete", tag: "div" } },
                  _vm._l(_vm.users.data, function(user) {
                    return _c(
                      "div",
                      { key: user.id, staticClass: "k-table__row" },
                      [
                        _c("div", { staticClass: "k-table__cell" }, [
                          _c("div", { staticClass: "k-table__cell-image" }, [
                            _c("img", {
                              attrs: {
                                src: user.prev_url,
                                alt: "",
                                height: "67px"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "mr-auto",
                              attrs: { href: user.detail_url }
                            },
                            [
                              _c("strong", { staticClass: "k-strong" }, [
                                _vm._v(_vm._s(user.name))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "k-table__cell k-table__cell--meta-lg"
                          },
                          [
                            _c("div", { staticClass: "k-table__cell-meta" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(user.login_history_count) +
                                  "\n                        "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "k-table__cell k-table__cell--meta" },
                          [
                            _c("div", { staticClass: "k-table__cell-meta" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(user.documents_count) +
                                  "\n                        "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "k-table__cell k-table__cell--meta" },
                          [
                            _c("div", { staticClass: "k-table__cell-meta" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(user.discussions_count) +
                                  "\n                        "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "k-table__cell k-table__cell--meta" },
                          [
                            _c("div", { staticClass: "k-table__cell-meta" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(user.comments_count) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("pagination", {
              staticClass: "mt-4",
              attrs: { data: _vm.users },
              on: { "pagination-change-page": _vm.paginate }
            })
          ]
        : [
            _vm.users.data && _vm.users.data.length === 0
              ? _c("div", { staticClass: "k-table" }, [_vm._m(1)])
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "k-table__header" }, [
      _c("div", { staticClass: "k-table__cell" }, [
        _vm._v("\n                    Jméno\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "k-table__cell k-table__cell--meta-lg" }, [
        _vm._v("\n                    Počet přihlášení\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "k-table__cell k-table__cell--meta" }, [
        _vm._v("\n                    Dokumenty\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "k-table__cell k-table__cell--meta" }, [
        _vm._v("\n                    Příspěvky\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "k-table__cell k-table__cell--meta" }, [
        _vm._v("\n                    Komentáře\n                ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "k-table__row" }, [
      _c("div", { staticClass: "k-table__cell p-2 justify-content-center" }, [
        _vm._v(
          "\n                    Nebyl nalezen žádný uživatel.\n                "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }